import { ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import { HomeRoomSection, HomeRoomSectionNameFragment } from "../../../../Utilities";
import { HomeRoomSectionFormat } from "../../../Format";
import styles from "./styles.module.css";

export type IconHomeRoomSection = Pick<HomeRoomSection, "id"> & HomeRoomSectionNameFragment;

export type HomeRoomSectionIconProps = {
	homeRoomSection: IconHomeRoomSection;
	size?: string;
} & Partial<ClassNameProps & StyleProps>;

export function HomeRoomSectionIcon({ homeRoomSection, size = "2rem", className, style }: HomeRoomSectionIconProps) {
	const text = HomeRoomSectionFormat.abbreviatedName(homeRoomSection);
	const textLength = text.length;
	const textScale = textLength === 1 ? 1 / 2.25 : 1 / Math.max(textLength, 1);

	return (
		<div
			className={makeClassName(styles["home-room-section-icon"], className)}
			style={{ "--size": size, "--text-scale": textScale, ...style } as React.CSSProperties}
		>
			<div className={styles["home-room-section-icon__content"]}>
				<span>{text}</span>
			</div>
		</div>
	);
}
